import React from 'react';
import {
  TASK_ICON_CLASSES,
  TASK_LABEL_CLASSES,
  TASK_ROW_CLASSES,
  getTaskItemClasses,
} from './TaskItem.styles';
import type { TaskItemProps } from './TaskItem.types';

export const TaskItem = <TEvent,>({
  event,
  level = 0,
  children = [],
  isLastInGroup = false,
  getUniqueKey,
  getDisplayName,
  renderIcon,
  testIdPrefix,
}: TaskItemProps<TEvent>) => {
  const uniqueKey = getUniqueKey(event);
  const hasChildren = children && React.Children.count(children) > 0;

  return (
    <div
      data-testid={`${testIdPrefix}-${uniqueKey}`}
      className={getTaskItemClasses(level, isLastInGroup)}
    >
      <div data-testid={`${testIdPrefix}-${uniqueKey}-row`} className={TASK_ROW_CLASSES}>
        <div data-testid={`${testIdPrefix}-${uniqueKey}-icon`} className={TASK_ICON_CLASSES}>
          {renderIcon(event)}
        </div>
        <p className={TASK_LABEL_CLASSES}>{getDisplayName(event)}</p>
      </div>

      {hasChildren && <div>{children}</div>}
    </div>
  );
};
